import React from "react";
import { BreadcrumbTrail } from "@/components/BreadcrumbTrail";
import { StepperTrail } from "@/components/StepperTrail";

interface MaturityLayoutProps {
  children: React.ReactNode;
  section: string;
  index?: number;
  total?: number;
  stepIndex?: number;
  projectData?: {
    id: string;
    name: string;
    client_org?: string;
  };
}

export const MaturityLayout = ({ children, section, index, total, stepIndex, projectData }: MaturityLayoutProps) => {
  return (
    <div className="p-6">
      <BreadcrumbTrail section={section} index={index} total={total} projectData={projectData} />
      {typeof stepIndex === "number" && <StepperTrail activeIndex={stepIndex} />}
      {children}
    </div>
  );
};